<div class="card">
  <div class="header">
    <div>
      <span>ID </span>
      <span>{{ budget?.numeroOrcamento || numeroPedido(budget) }}</span>
    </div>
  </div>
  <div class="body">
    <div class="prop">
      <small>CLIENTE: </small>
      <span>{{ budget?.nomeCliente }}</span>
    </div>
    <div class="prop">
      <small>VALOR: </small>
      <span>{{ budget?.valorTotalOrcamento | currency: "BRL" }}</span>
    </div>
    <div class="prop">
      <small>FEITO EM: </small>
      <span>{{ budget?.dataCriacaoObra | date: "dd/MM/YYYY" }}</span>
    </div>
  </div>
  <div class="footer">
    <app-button text="Selecionar" (click)="choose.emit()"></app-button>
  </div>
</div>
